import React from "react";
import subscriptionModalClient from "../../logic/subscriptionModal";
import { IonIcon } from "@ionic/react";
import { close } from "ionicons/icons";
import { useParams } from "react-router";
import { useRestaurant } from "../../utils/contexts/restaurant-context";
import { useTranslation } from "react-i18next";
import "./SubscriptionModalContentStyle.css";

export default function SubscriptionModalContent(props) {
    const { closerHandler } = props;

    const { id } = useParams();
    const { restaurant } = useRestaurant();
    const { t } = useTranslation();

    async function submitHandler(evt) {
        evt.preventDefault();
        const form = new FormData(evt.target);
        const formObj = Object.fromEntries(form);
        await subscriptionModalClient.doPost(formObj);
        let storage = window.localStorage.getItem("has_subscription");
        let obj = [{ id }];
        if (storage) {
            obj = JSON.parse(storage);
            obj.push({ id });
        }

        window.localStorage.setItem("has_subscription", JSON.stringify(obj));
        closerHandler();
    };

    return (
        <div className="subscription-modal-content overflow-auto text-black">
            <div className="relative mb-4 px-4">
                <button type="button" onClick={closerHandler} className="z-10 absolute text-2xl top-0 right-0 flex items-center justify-center mt-4 p-3 pb-0">
                    <IonIcon slot="icon-only" icon={close}></IonIcon>
                </button>
            </div>

            <form className="pb-4 p-1 px-8 mb-3" onSubmit={submitHandler}>
                <p className="px-3 border-b border-b-gray-600">{t("subscriptionmodalcontent.p_1")}</p>
                <fieldset className="pt-3 text-sm">
                    <input type="hidden" name="ris_id" value={restaurant.id} />
                    <div>
                        <label htmlFor="name" className="sr-only"></label>
                        <input type="text" name="name" id="name" className="w-full mt-2 py-3 px-4 rounded-lg bg-grey-200" placeholder={t("subscriptionmodalcontent.input_1.placeholder_1")} required />
                    </div>
                    <div>
                        <label htmlFor="lastname" className="sr-only"></label>
                        <input type="text" name="lastname" id="lastname" className="w-full mt-2 py-3 px-4 rounded-lg bg-grey-200" placeholder={t("subscriptionmodalcontent.input_1.placeholder_2")} required />
                    </div>
                    <div>
                        <label htmlFor="email" className="sr-only"></label>
                        <input type="email" name="email" id="email" className="w-full mt-2 py-3 px-4 rounded-lg bg-grey-200" placeholder={t("subscriptionmodalcontent.input_1.placeholder_3")} required />
                    </div>
                    <div>
                        <label htmlFor="phone" className="sr-only"></label>
                        <input type="text" name="phone" id="phone" className="w-full mt-2 py-3 px-4 rounded-lg bg-grey-200" placeholder={t("subscriptionmodalcontent.input_1.placeholder_4")} required />
                    </div>
                </fieldset>
                <div className="pt-6">
                    <fieldset className="text-xs">
                        <div>
                            <input type="checkbox" name="agree" id="agree" className="mx-3" required />
                            <label>{t("subscriptionmodalcontent.consent_1.before_link")} <a href="https://www.iubenda.com/privacy-policy/67338862" className="underline">{t("subscriptionmodalcontent.consent_1.link_text")}</a>{t("subscriptionmodalcontent.consent_1.after_link")}</label>
                        </div>
                        <div>
                            <input type="checkbox" name="second-agree" id="second-agree" className="mx-3" required />
                            <label>{t("subscriptionmodalcontent.consent_2.before_link")} <a href="https://..." className="underline cursor-pointer">{t("subscriptionmodalcontent.consent_2.link_text")}</a> {t("subscriptionmodalcontent.consent_2.after_link")}</label>

                        </div>
                    </fieldset>
                    <button type="submit" className="my-2 py-2 px-4 w-full border border-blue-400 rounded-full">{t("subscriptionmodalcontent.button_1")}</button>
                </div>
            </form>

            <div className="text-center">
                <button className="underline" onClick={closerHandler}>{t("subscriptionmodalcontent.button_2")}</button>
            </div>
        </div>
    );
}
